import { createSlice, PayloadAction } from '@reduxjs/toolkit';



export type StateColor ={
    colorSelected:string,
    transitionSelected:string,
    isError:boolean
}

const initialState:StateColor = {
    colorSelected:null,
    transitionSelected:null,
    isError:false
};

const colorSlice = createSlice({
    name: 'colorSelected',
    initialState: initialState,
    reducers: {
        selectColor: (state,{payload}: PayloadAction<string>) => {
            state.colorSelected=payload;
        },
        selectTransition: (state,{payload}: PayloadAction<string>) => {
            state.transitionSelected=payload;
        },
        setError:(state,{payload}: PayloadAction<boolean>) =>{
            state.isError=payload;
        }
    },
  });

export const colorReducer = colorSlice.reducer;
export const colorActions = colorSlice.actions;